module.exports = __webpack_public_path__ + "media/images/emblems/Niederglatt-blazon-424cc71ec01bb76bc2648b95af50218d.svg";